import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Card } from '@otp/ui';
import { Link } from 'src/components/common/link';
import { Routes } from 'src/components/common/router/constants';
import {
  StoreAssignmentFilter,
  StoresNeedAttentionDocument,
  StoresNeedAttentionQuery,
} from 'src/graphql/generated/graphql';
import { RestaurantListItem } from './restaurant-list-item';
import { useQuery } from '@apollo/client';
import Grid from '@mui/material/Grid';
import { ErrorNotification as ErrorNotificationIcon } from '@otp/icons';

export const RestaurantList = () => {
  const { t } = useTranslation();
  const { data } = useQuery<StoresNeedAttentionQuery>(
    StoresNeedAttentionDocument,
    {
      variables: {
        filter: { storeAssignment: [StoreAssignmentFilter.NeedAttention] },
        pagination: {
          limit: 5,
          offset: 0,
        },
      },
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-and-network',
    },
  );
  const storesNeedAttention = data?.stores?.records || [];

  return (
    <Link
      to={Routes.restaurants.path}
      queryParams={{
        filter: { storeAssignment: [StoreAssignmentFilter.NeedAttention] },
      }}
      className="h-full"
    >
      <Card
        className="bg-[#F8F9FD] p-6 border-none w-full h-full flex flex-col"
        isLink
        linkPosition="top"
        linkIconClassName="mt-[18px]"
      >
        <Grid container spacing={3}>
          {/* Header Section */}
          <Grid container item xs={12} alignItems="center" gap={2}>
            <ErrorNotificationIcon />
            <Typography
              component="div"
              variant="body1"
              fontWeight="medium"
              fontFamily="Inter"
              className="font-semibold"
            >
              {t('my-organisation.requires-attention')}
            </Typography>
          </Grid>
          <Grid container item xs={12} gap={2}>
            {storesNeedAttention.length > 0 ? (
              storesNeedAttention.map((restaurant, i) => (
                <RestaurantListItem
                  key={restaurant.id}
                  restaurant={restaurant}
                  isLast={i === storesNeedAttention?.length - 1}
                />
              ))
            ) : (
              <Grid container justifyContent="center" alignItems="center" className="py-4 w-full">
                <Typography variant="body2" color="text.secondary">
                  {t('common.no-data-available')}
                </Typography>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Card>
    </Link>
  );
};
